import { useQuery } from '@tanstack/react-query';
import { activitiesApi } from '@/lib/api';

export function useActivities(params?: Parameters<typeof activitiesApi.list>[0]) {
  return useQuery({
    queryKey: ['activities', params],
    queryFn: () => activitiesApi.list(params),
    enabled: !!(params?.contactId || params?.organizationId || params?.dealId),
  });
}
